import gql from 'graphql-tag';

export const PRICE_HISTORY_FRAGMENT = gql`
    fragment PRICE_HISTORY_FRAGMENT on ListingData {
        priceHistory {
            firstPublished {
                firstPublishedDate
                priceLabel
            }
            lastSale {
                date
                newBuild
                price
                priceLabel
                recentlySold
            }
            priceChanges {
                isMinorChange
                isPriceDrop
                isPriceIncrease
                percentageChangeLabel
                priceChangeDate
                priceChangeLabel
                priceLabel
            }
        }
        viewCount {
            viewCount30day
        }
    }
`;
